import { Typography } from '@mui/material'
import React, { memo, useCallback } from 'react'
import tw from 'twin.macro'
import MVRIcon from 'src/assets/icons/bgc.svg'
import { CollectDataStepIndex } from 'src/components/client/CollectDataStepIndex'
import { useSelector } from 'react-redux'
import { getCurrentCollectDataStep } from 'src/selectors/collectData'
import { useYardstik } from 'src/hooks/useYardstik'
import { MVRCollectDataStep } from 'src/interfaces/collectData'
import { Button } from '../shared/Button'

const MVRYardstikComponent = () => {
  const currentStep = useSelector(getCurrentCollectDataStep) as MVRCollectDataStep

  const { isYardstikLoading, startYardstik, YardstikView } = useYardstik()

  const showYardstik = useCallback(() => {
    startYardstik(currentStep.id)
  }, [currentStep.id])

  return (
    <>
      <div css={tw`h-full w-full flex flex-col justify-between`}>
        <div>
          <div
            css={tw`w-11 h-11 flex justify-center items-center [border-radius: 22px] bg-shades-100 mt-2 mb-4`}
          >
            <img src={MVRIcon} />
          </div>
          <CollectDataStepIndex stepId={currentStep.id} />
          <Typography css={tw`mb-2 mt-2`} variant="h2">
            Motor Vehicle Record
          </Typography>
          <Typography css={tw`mb-4 text-shades-400`}>
            To conduct your Motor Vehicle Record report we'll use our industry leading partner,
            Yardstik. Tap “Proceed with Yardstik” button below to begin.
          </Typography>
        </div>
        <Button className={tw`w-full`} loading={isYardstikLoading} onClick={showYardstik}>
          Proceed with Yardstik
        </Button>
      </div>
      <YardstikView />
    </>
  )
}

export const MVRYardstik = memo(MVRYardstikComponent)
